module.exports = __webpack_public_path__ + "img/logoresult.e13c6b91.png";